var _path, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuperstar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.2977 7.41641C52.1016 5.37925 55.8984 5.37926 58.7023 7.41641L100.655 37.8967C103.459 39.9338 104.632 43.5448 103.561 46.8409L87.5365 96.1591C86.4655 99.4552 83.3939 101.687 79.9281 101.687H28.0719C24.6061 101.687 21.5345 99.4552 20.4635 96.1591L4.43906 46.8409C3.36806 43.5448 4.54133 39.9338 7.34523 37.8967L49.2977 7.41641Z",
    fill: "#F9FAFB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_139_1189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4733 12.5623C52.5762 11.0344 55.4238 11.0344 57.5267 12.5623L96.124 40.6049C98.2269 42.1327 99.1069 44.8409 98.3036 47.3131L83.5608 92.6869C82.7575 95.159 80.4538 96.8328 77.8544 96.8328H30.1456C27.5462 96.8328 25.2425 95.1591 24.4392 92.6869L9.69637 47.3131C8.89313 44.8409 9.77308 42.1327 11.876 40.6049L50.4733 12.5623Z",
    fill: "url(#paint0_linear_139_1189)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_139_1189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1839 29.9373C52.8987 28.3876 55.1013 28.3876 55.8161 29.9373L62.5595 44.5569C62.8508 45.1885 63.4494 45.6234 64.1401 45.7053L80.128 47.6009C81.8228 47.8019 82.5034 49.8966 81.2504 51.0554L69.4302 61.9864C68.9195 62.4587 68.6908 63.1623 68.8264 63.8446L71.9641 79.6357C72.2967 81.3096 70.5148 82.6043 69.0256 81.7707L54.9769 73.9068C54.3699 73.5671 53.6301 73.5671 53.0231 73.9068L38.9744 81.7707C37.4852 82.6043 35.7033 81.3096 36.0359 79.6357L39.1736 63.8446C39.3092 63.1623 39.0805 62.4587 38.5698 61.9864L26.7496 51.0554C25.4966 49.8966 26.1772 47.8019 27.872 47.6009L43.8599 45.7053C44.5506 45.6234 45.1492 45.1885 45.4405 44.5569L52.1839 29.9373Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0918 30.3564C53.4492 29.5816 54.5508 29.5816 54.9082 30.3564L61.6514 44.9756C62.0884 45.923 62.9864 46.5754 64.0225 46.6982L80.0098 48.5938C80.8572 48.6942 81.1978 49.7419 80.5713 50.3213L68.751 61.252C67.9851 61.9603 67.6425 63.0158 67.8457 64.0391L70.9834 79.8311C71.1493 80.6678 70.2581 81.3152 69.5137 80.8984L55.4648 73.0342C54.5546 72.5248 53.4454 72.5249 52.5352 73.0342L38.4863 80.8984C37.7419 81.3152 36.8507 80.6678 37.0166 79.8311L40.1543 64.0391C40.3575 63.0158 40.0149 61.9603 39.249 61.252L27.4287 50.3213C26.8022 49.7419 27.1428 48.6942 27.9902 48.5938L43.9775 46.6982C45.0136 46.5754 45.9116 45.923 46.3486 44.9756L53.0918 30.3564Z",
    stroke: "url(#paint1_linear_139_1189)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_139_1189",
    x: 9.4023,
    y: 11.4164,
    width: 89.1954,
    height: 85.4164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_139_1189"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_139_1189",
    x: 26.1051,
    y: 28.775,
    width: 55.7899,
    height: 57.2556,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_139_1189"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_139_1189",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_139_1189",
    x1: 102,
    y1: 106,
    x2: 14.4969,
    y2: 2.7958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FF3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF3B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_139_1189",
    x1: 86,
    y1: 90,
    x2: 27.6646,
    y2: 21.1972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FF3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF3B00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperstar);
export default __webpack_public_path__ + "static/media/superstar.7526397c36f38e18c0eb409b8cf0c6a1.svg";
export { ForwardRef as ReactComponent };